import { FC, useEffect, useMemo, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { FallbackView } from '../../../_metronic/partials';
import { useUserSections } from '../../context/UserSectionContext';
import { userSections } from '../../enums/userSections';
import ClaimsPage from './ClaimsPage';
import { DEFAULT_ROUTE } from '../../routing/routes.config';

const ClaimsPageWrapper: FC = () => {
  const {sections, loading} = useUserSections();
  const hasClaims = useMemo(() => {
      if(loading)
        return null;

      return sections.some(s => s.section.trim() === userSections.CLAIM);
  }, [sections, loading]);

  if(hasClaims === null || loading)
    return <FallbackView />
  
  if(!hasClaims)
    return <Redirect to={DEFAULT_ROUTE} />
    
  return <ClaimsPage />
}

export default ClaimsPageWrapper
